import PropTypes from 'prop-types';
import React, { Component } from 'react';

class CityStateDetails extends Component {
  static propTypes = {
    city: PropTypes.string,
    state: PropTypes.string,
  };

  getText() {
    if (this.props.city && !this.props.state) {
      return this.props.city;
    }
    if (this.props.state && !this.props.city) {
      return this.props.state;
    }
    return `${this.props.city}/${this.props.state}`;
  }

  render() {
    return (
      <p className="system-details">
        {this.getText()}
      </p>
    );
  }
}

export default CityStateDetails;
